module.exports = __webpack_public_path__ + "654a752f19c125c491ab7ab920706360.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/biofar sa.png
// module id = 587
// module chunks = 0